import { CONFIG_PADRAO, type Eixo, Maturidade, type NivelMaturidade, nivelRisco, num1 } from "@caint/engine";

export interface MatBadgeProps {
  m: NivelMaturidade | null | "";
}

/** Badge de maturidade: número + situação (curva ONA). */
export function MatBadge({ m }: MatBadgeProps) {
  if (m == null || m === "") {
    return (
      <span className="mat mat-na">
        <span className="num">—</span>
      </span>
    );
  }
  if (m === "na") {
    return (
      <span className="mat mat-na">
        <span className="num">NA</span>
      </span>
    );
  }
  const mat = Maturidade.de(m);
  return (
    <span className={`mat mat-${m}`}>
      <span className="num">{m}</span>
      {mat.situacao}
    </span>
  );
}

const OPCOES: readonly NivelMaturidade[] = ["0", "1", "2", "3", "4", "na"];

export interface MatSelectProps {
  value: NivelMaturidade | null;
  onChange: (v: NivelMaturidade) => void;
}

/** Seletor em grade (0–4/NA); o botão selecionado assume a cor do nível. */
export function MatSelect({ value, onChange }: MatSelectProps) {
  return (
    <div className="m-mat">
      {OPCOES.map((o) => (
        <button
          key={o}
          type="button"
          data-v={o}
          className={value === o ? "on" : ""}
          onClick={() => onChange(o)}
        >
          {o === "na" ? "NA" : o}
        </button>
      ))}
    </div>
  );
}

export interface RiskBadgeProps {
  value: number | null;
  withVal?: boolean;
}

/** Badge do nível de risco residual (RP/RM/RA/RC). */
export function RiskBadge({ value, withVal }: RiskBadgeProps) {
  const nivel = nivelRisco(value, CONFIG_PADRAO);
  if (value == null || nivel == null) {
    return (
      <span className="risk risk-rp" style={{ opacity: 0.4 }}>
        —
      </span>
    );
  }
  return (
    <span className={`risk risk-${nivel.toLowerCase()}`}>
      {withVal ? `${num1(value)} · ` : ""}
      {nivel}
    </span>
  );
}

export function EixoChip({ eixo }: { eixo: Eixo }) {
  return <span className={`chip chip-eixo chip-${eixo.toLowerCase()}`}>{eixo}</span>;
}

const PESO: Record<1 | 2 | 3, readonly [string, string]> = {
  3: ["chip-core", "CORE"],
  2: ["chip-imp", "Imp."],
  1: ["chip-des", "Desej."],
};

export function PesoChip({ peso }: { peso: 1 | 2 | 3 }) {
  const [cls, lbl] = PESO[peso];
  return <span className={`chip ${cls}`}>{lbl}</span>;
}
